// The Work Effort panel's data sources from its three reads (Promise.allSettled results of
// getSchemas, getUploads, getConnections). A read that failed, or answered a shape with no
// list, lands in `errors` under its name and its list is empty -- the panel says
// "couldn't load …" for it rather than showing nothing.
//
// Plain module, so tests can run it under node.
import { settledList } from './loadState.js'

export function dataSourcesFrom(schemas, uploads, connections) {
  const errors = {}
  const take = (result, name, ...keys) => {
    const { items, error } = settledList(result, ...keys)
    if (error) errors[name] = error
    return items || []
  }
  const tables = take(schemas, 'tables', 'tables')
  const body = schemas?.status === 'fulfilled' ? schemas.value : null
  // a 200 body that reports `error` is a failed read too
  if (body?.error) errors.tables = String(body.error)
  // the tables are real but where they came from could not be read (table_metadata):
  // they list as "source not recorded", and the panel says why
  if (body?.metadata_error) errors['table sources'] = String(body.metadata_error)
  return {
    tables,
    uploads: take(uploads, 'uploads', 'uploads'),
    connections: take(connections, 'connections'),
    errors,
  }
}

// Whether the Data Sources block has anything to show: a list with entries, or a failure
// to say. A customer with connections and no tables yet still sees them (and Pull Data).
export const hasDataSources = (ds) =>
  !!(ds && ((ds.tables || []).length || (ds.uploads || []).length || (ds.connections || []).length
    || Object.keys(ds.errors || {}).length))
